import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@telegram-apps/telegram-ui/dist/styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/normalize.css/normalize.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Root"] */ "/vercel/path0/src/components/Root/Root.tsx");
